import zustand from 'zustand';
import produce from 'immer'

export default class Control {
  static Get(name){
    return useStoreControl(s => s[name]);
  }
}

// Control
// These valiables are require for control UI.
// These are not necesary to save to file.
const [useStoreControl] = zustand((set, get) => {
  const disCamera = 500;

  return {
    setControl: n => set(produce(n)),
  
    orthographic: true,
    currentAngle: 0,        //0:Free 1:Front 2:Back 3:Top 4:Bottom 5:Right 6:Left 7:Lock
    cameraPosition: [0, 0, disCamera],
    
    SetCamera(angle){
      if(angle==1)      get().SetCameraFront();
      else if(angle==2) get().SetCameraBack();
      else if(angle==3) get().SetCameraTop();
      else if(angle==4) get().SetCameraBottom();
      else if(angle==5) get().SetCameraRight();
      else if(angle==6) get().SetCameraLeft();
    },
    SetCameraFree() {
      set({ currentAngle: 0,
            flgOrbitEnable: true,
            orthographic: true}); 
    },
    SetCameraLock() {
      set({ currentAngle: 7,
            flgOrbitEnable: false,
            orthographic: true}); 
    },
    SetCameraFront(h) {
      // run setcamerafree
      get().SetCameraFree()
      set({ cameraPosition: [0, 0, disCamera],
            currentAngle: 1,
            flgOrbitEnable: false,
            orthographic: true}); 
    },
    SetCameraBack() {
      get().SetCameraFree()
      set({ cameraPosition: [0, 0, -disCamera],
            currentAngle: 2,
            flgOrbitEnable: false,
            orthographic: true}); 
    },
    SetCameraTop() {
      get().SetCameraFree()
      set({ cameraPosition: [0,disCamera,0],
            currentAngle: 3,
            flgOrbitEnable: false,
            orthographic: true}); 
    },
    SetCameraBottom() {
      get().SetCameraFree()
      set({ cameraPosition: [0,-disCamera,0],
            currentAngle: 4,
            flgOrbitEnable: false,
            orthographic: true}); 
    },
    SetCameraRight(h) {
      get().SetCameraFree()
      set({ cameraPosition: [-disCamera,0,0],
            currentAngle: 5,
            flgOrbitEnable: false,
            orthographic: true}); 
    },
    SetCameraLeft(h) {
      get().SetCameraFree()
      set({ cameraPosition: [disCamera,0,0],
            currentAngle: 6,
            flgOrbitEnable: false,
            orthographic: true}); 
    },
    SetCameraOut(side, h) {
      get().SetCameraFree()
      if(side == 1) get().SetCameraRight(h);
      else get().SetCameraLeft(h);
    },
    SetCameraIn(side, h) {
      get().SetCameraFree()
      if(side == 1) get().SetCameraLeft(h);
      else get().SetCameraRight(h);
    },

    showMirror: 0,
    measure: false,

    type: '',             // '' / TestSocket / Final
    prosthetics: 'BK', // BK, AK
    tsfd: null,
    settingType: '',      // '' / CAE / ...
    click: null,          // THREE.Vector3
    origin: [0, 0, 0],         // THREE.Vector3
    showLeg: true,
    showSocket: true, // 
    showTrimSurface: true, // TrimSurface
    showFinal: true,
    showCAE: true,
    wireLeg: false,
    transparentLeg: false,
    wireSocket: false,
    wireFinal: false,
    meshLeg: null,
    alignedMeshLeg : null, // After alignment, it is used to output
    pointCross: null,      // Cross section curve
    pointMerdian: null,    // Merdian curve
    meshSocketCompress: null, // Compress
    meshSocketCompressVtk: null,
    meshSocketModify: null, // Modify
    meshSocketModifyVtk: null,
    meshSocketTrim: null, // Trimming
    meshSocketTrimVtk: null,
    meshSocketThick: null, // Thicken
    meshSocketThickVtk: null,
    meshSocketJoint: null, // Joint
    meshSocketJointVtk: null,
    
    
    meshSocketF10: null,  // Compress
    meshSocketF11: null,  // Modify
    meshSocketF14: null,  // Trimming
    meshSocketF16: null,  // Thick
    meshSocketF17: null,  // Joint
    meshSocketF26: null,  // Reinforth
    meshFinal: null,
    meshCAE: null,
    meshSole: null,       // Original Data
    meshKeelU: null,
    meshKeelL: null,
    meshSole2: null,      // For transform
    meshKeelU2: null,
    meshKeelL2: null,
    meshCube: null,
    meshCross: null,
    photoFront: null,
    photoSide: null,
    flgOrbitEnable: true,
    flgLegClickable: true,
    flgSocketClickable: false,
    toCenter: false, // For alignment button, to Center
    toCenterButton: false, // For alignment button, to Center
    toModifyCenter: false, // At first of compress
    toModifyYheight: false,
    redrawBox: false,
    redrawAngle: false,
    showCircle: false,
    showBound: true,
    showLine: true,

    // AK
    projectPoints: null,
    meshTrim1LowerSurface: null,
    meshTrim2UpperSurface: null,
    meshTrim2UpperSurfaceSi: null,
    meshTrim2UpperSurfaceMl: null,
    meshTrim2UpperSurfaceAp: null,
    meshOutputAk: null,
    
    //meshFileFoot: './static/joint/cube.stl',
    meshFileFoot: './static/24R_foot.stl',
    meshFileKnee: './static/knee_poly.stl',
    meshAdapter: null,
    meshRotationCenter: null,
    meshRotationCenter2: null,
    meshRotationCenter3: null,
  };
});